<template>
  <div>
    <report-panel :anchor="''">
      <div slot="title">Subsidiary Companies</div>
      <div slot="body">
        <!-- panel content start -->
        <table class="table table-striped" id="subsidiary-companies-table">
          <tbody>
            <tr v-if="report.companyoverview.groupsubsidiaries.length === 0">
              <td colspan="3">No subsidiaries found</td>
            </tr>
            <tr v-if="report.companyoverview.groupsubsidiaries.length !== 0">
              <th scope="row">Company:</th>
              <th scope="row">Country:</th>
              <th scope="row"></th>
            </tr>

            <tr v-for="subsidiary in report.companyoverview.groupsubsidiaries" :key="subsidiary.id">
              <td>
                {{ subsidiary.name }}
              </td>
              <td>
                <div class="static" v-bind:class="getFlag(subsidiary.country.code)"></div>
                {{ subsidiary.country.code.toUpperCase() }}
              </td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
        <!-- panel content end -->
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report'],
};
</script>
